import React from 'react';
import { AlertTriangleIcon, CheckIcon, ReceiptIcon, SparklesIcon } from 'lucide-react';
function SalesVisual() {
  return <div className="space-y-2" data-id="element-1402" data-mp="28mohzqgxpn4i">
      <div className="rounded-[8px] bg-white px-3 py-2.5 shadow-[0_10px_26px_-20px_rgba(11,11,11,0.5)]" data-id="element-1403" data-mp="28nzmxtm490x7">
        <div className="flex items-center justify-between" data-id="element-1404" data-mp="2dncg0w3kz488">
          <span className="text-[11px] font-medium text-ink" data-id="element-1405" data-mp="2hncuuhuldhft">Sale #1284</span>
          <span className="inline-flex items-center gap-1 rounded-full bg-brand px-2 py-0.5 text-[10px] font-semibold text-white" data-id="element-1406" data-mp="2mmg125mb5tpd">
            <ReceiptIcon className="h-2.5 w-2.5" aria-hidden="true" data-id="element-1407" data-mp="2rj6d8huzs55i" />
            Receipt
          </span>
        </div>
        <div className="mt-2 h-2 w-2/3 rounded-full bg-canvas-line" data-id="element-1408" data-mp="2wdkdoyoih2h1" />
      </div>
      <div className="flex items-center justify-between rounded-[8px] bg-white px-3 py-2.5 shadow-[0_10px_26px_-20px_rgba(11,11,11,0.5)]" data-id="element-1409" data-mp="319rcm7ihpdph">
        <span className="text-[11px] font-medium text-ink" data-id="element-1410" data-mp="3aaz9cl5cy6hg">Total</span>
        <span className="text-[11px] font-semibold text-ink" data-id="element-1411" data-mp="3a96336ynpo9z">$76.50</span>
      </div>
    </div>;
}
function InventoryVisual() {
  return <div className="space-y-2" data-id="element-1412" data-mp="3exc5ywz1kf2">
      {[['Cooking oil · 1L', '6 left', true], ['Sugar · 500g', '18 left', false]].map(([label, count, low]) => <div key={label as string} className="flex items-center justify-between rounded-[8px] bg-white px-3 py-2.5 shadow-[0_10px_26px_-20px_rgba(11,11,11,0.5)]" data-id="element-1413" data-mp="3pmn5zbobb18g">
          <span className="text-[11px] font-medium text-ink" data-id="element-1414" data-mp="r6uaqobeufy8">{label as string}</span>
          <span className={`text-[11px] font-semibold ${low ? 'text-brand' : 'text-ink-muted'}`} data-id="element-1415" data-mp="m819pvdb8hey">
            {count as string}
          </span>
        </div>)}
      <div className="flex items-center gap-1.5 rounded-[8px] bg-white px-3 py-2.5 text-[11px] font-medium text-brand shadow-[0_10px_26px_-20px_rgba(11,11,11,0.5)]" data-id="element-1416" data-mp="cfv6tqlisfkz">
        <AlertTriangleIcon className="h-3 w-3" aria-hidden="true" data-id="element-1417" data-mp="154j0oakc4da5" />
        Time to reorder
      </div>
    </div>;
}
function ExpenseVisual() {
  return <div className="space-y-2" data-id="element-1418" data-mp="2zf0ml1xj7aid">
      {['Fuel · Delivery', 'Packaging · Supplies'].map(label => <div key={label} className="flex items-center justify-between rounded-[8px] bg-white px-3 py-2.5 shadow-[0_10px_26px_-20px_rgba(11,11,11,0.5)]" data-id="element-1419" data-mp="2pmuttpzggp24">
          <span className="text-[11px] font-medium text-ink" data-id="element-1420" data-mp="2ujtktzntofw3">{label}</span>
          <span className="inline-flex items-center gap-1 rounded-full bg-brand px-2 py-0.5 text-[10px] font-semibold text-white" data-id="element-1421" data-mp="2fn3y5kz5s40g">
            <SparklesIcon className="h-2.5 w-2.5" aria-hidden="true" data-id="element-1422" data-mp="2kldva14g1eop" />
            Auto
          </span>
        </div>)}
      <div className="flex items-center gap-1.5 rounded-[8px] bg-white px-3 py-2.5 text-[11px] font-medium text-[#1B7A3D] shadow-[0_10px_26px_-20px_rgba(11,11,11,0.5)]" data-id="element-1423" data-mp="2bmsiynpkevwd">
        <CheckIcon className="h-3 w-3" aria-hidden="true" data-id="element-1424" data-mp="4urmnbvgi55k" />
        Categorized
      </div>
    </div>;
}
function ReportsVisual() {
  return <div className="rounded-[8px] bg-white p-3 shadow-[0_10px_26px_-20px_rgba(11,11,11,0.5)]" data-id="element-1425" data-mp="jyuhok8brckt">
      <div className="flex h-[62px] items-end gap-1.5" data-id="element-1426" data-mp="f1c4uir6sd7j">
        {[42, 58, 50, 72, 64, 88].map((h, i) => <div key={i} className={`flex-1 rounded-t-[3px] ${i === 5 ? 'bg-brand' : 'bg-canvas-line'}`} style={{
        height: `${h}%`
      }} data-id="element-1427" data-mp="sszb9beuf241" data-mpi={i} />)}
      </div>
      <p className="mt-3 text-[11px] font-semibold text-ink" data-id="element-1428" data-mp="12p2ekklfl6sk">Profit up 18%</p>
    </div>;
}
function FinanceVisual() {
  return <div className="rounded-[8px] bg-white p-3 shadow-[0_10px_26px_-20px_rgba(11,11,11,0.5)]" data-id="element-1429" data-mp="xqsebvkung03">
      <div className="flex items-center justify-between" data-id="element-1430" data-mp="1bq0il2vvdeb5">
        <span className="text-[11px] font-medium text-ink" data-id="element-1431" data-mp="17oyjcm1yd296">Eligibility</span>
        <span className="text-[11px] font-semibold text-brand" data-id="element-1432" data-mp="3dhwtcaa7qk4v">70%</span>
      </div>
      <div className="mt-2 h-[7px] w-full overflow-hidden rounded-full bg-canvas-line" data-id="element-1433" data-mp="3djzqrfdp3fjm">
        <div className="h-full w-[70%] rounded-full bg-brand" data-id="element-1434" data-mp="39inxmzvm4c6o" />
      </div>
      <div className="mt-3 space-y-1.5" data-id="element-1435" data-mp="3ax8jsfd1r33q">
        {['12 months of sales', 'Verified stock records'].map(label => <p key={label} className="flex items-center gap-1.5 text-[10.5px] text-ink-muted" data-id="element-1436" data-mp="3fyxx61nqrsuz">
            <CheckIcon className="h-3 w-3 text-brand" aria-hidden="true" data-id="element-1437" data-mp="3jz869n6tyze2" />
            {label}
          </p>)}
      </div>
    </div>;
}
const tiles = [{
  title: 'Point of Sale',
  copy: 'Make sales, issue receipts, and keep every transaction in one place.',
  visual: <SalesVisual data-id="element-1438" data-mp="2w9dqoxv4mwq4" />
}, {
  title: 'Inventory',
  copy: 'Track stock in real time and know when it’s time to reorder.',
  visual: <InventoryVisual data-id="element-1439" data-mp="31649hsybg6f8" />
}, {
  title: 'Expenses',
  copy: 'Record business costs and see exactly where your money goes.',
  visual: <ExpenseVisual data-id="element-1440" data-mp="28k1ia07misov" />
}, {
  title: 'Reports & insights',
  copy: 'Understand your sales, profit, and cash flow with clear reports.',
  visual: <ReportsVisual data-id="element-1441" data-mp="2dg9xtepqgnwk" />
}, {
  title: 'Business financing',
  copy: 'Use your business records to check your eligibility for working capital.',
  visual: <FinanceVisual data-id="element-1442" data-mp="210s8i5v7grza" />
}];
export function ProductSuite() {
  return <section className="w-full bg-white py-20" aria-labelledby="suite-heading" data-id="element-1443" data-mp="1w04ldva3kvac">
      <div className="mx-auto max-w-shell px-6" data-id="element-1444" data-mp="1rz2jt7spk757">
        <h2 id="suite-heading" className="display text-center text-[32px] font-semibold text-ink sm:text-[40px]" data-id="element-1445" data-mp="1ryaozz6xqdfz">
          Your business runs better together.
        </h2>
        <p className="mx-auto mt-4 max-w-[620px] text-center text-[16px] leading-[1.5] text-ink-muted" data-id="element-1446" data-mp="1i8hfr4u9maew">
          Sell, manage stock, understand performance, and access capital in one place.
        </p>

        <ul className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5" data-id="element-1447" data-mp="18co5js40qt0a">
          {tiles.map(tile => <li key={tile.title} className="flex flex-col rounded-[14px] bg-canvas-warm p-6 transition-colors duration-200 ease-out hover:bg-[#EEEBE7]" data-id="element-1448" data-mp="14bkmkwqocguu">
              <h3 className="text-[17px] font-semibold leading-tight tracking-[-0.02em] text-ink" data-id="element-1449" data-mp="povrd73ggpu9">
                {tile.title}
              </h3>
              <p className="mt-2 text-[13px] leading-[1.5] text-ink-muted" data-id="element-1450" data-mp="fp4ytayggkwt">{tile.copy}</p>
              <div className="mt-8 flex flex-1 items-end" data-id="element-1451" data-mp="kn6dljouly2h">
                <div className="w-full" data-id="element-1452" data-mp="kpsjzg0067j4">{tile.visual}</div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}